module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAJCAYAAAALpr0TAAAAfElEQVQoU2NkQAP/9zIYMbAyVDDsY4hgbGD4B5NmxFC4n8GCgYnhOAMDw0RGe4YCuML/+xlkGFgYuJA06DP8Y1gF5v9nKGZ0YOgDMRn/H2T4zcDAwIJuMpT/j+E/QwSjA8NqkML/OBRBhP8zvGV0YBAhwURi3Ui0r4kNRwDRCS8KzK1MlQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/custom_mobile/jiantou.png
// module id = 88+T
// module chunks = 1